import React from 'react';
import LogBook from '../modules/Reports/LogBook';

const LogBookPage: React.FC = () => {
    return <LogBook />;
};

export default LogBookPage; 